import axios from "../../../utils/authAxios";
const api_base_url = process.env.REACT_APP_API_BASEURL;

export const getGLEntity = async () => {
  const { data } = await axios.get(`${api_base_url}/GLEntity`);
  return data;
};
export const addGLEntity = async (newOfficeType) => {
  const { data } = await axios.post(`${api_base_url}/GLEntity`, {
    ...newOfficeType[0],
  });
  return data;
};
export const updateGLEntity = async (updatedOfficeType) => {
  const { data } = await axios.put(
    `${api_base_url}/GLEntity/${updatedOfficeType[0].glentityId}`,
    updatedOfficeType[0]
  );
  return data;
};

export const deleteGLEntity = async (ids) => {
  await axios.delete(`${api_base_url}/GLEntity/`, {
    data: ids,
  });
};

//Search GLEntity
export const searchGLEntity = async (searchInputsData) => {
  if (searchInputsData === "") {
    searchInputsData = "0";
  }
  const data = {
    glNumber: parseInt(searchInputsData),
  };

  return await axios
    .post(`${api_base_url}/GLEntity/SearchGLEntity`, data)
    .then((res) => res.data);
};
